module.exports = __webpack_public_path__ + "img/card-satchelpay.b119a545.svg";